module.exports = __webpack_public_path__ + "static/bike-ce70a1514598d6154f6b3e2d8d9b380d.svg";